@import url(../../global/global.css);

:host {
  --border-display-radius: 8px;
  --display-card-height: 400px;
}

.dc-display-card-link {
  display: flex;
  width: 100%;
  height: 100%;
  border-radius: var(--border-display-radius);
  position: relative;
  text-decoration: none;
}

.dc-display-card-media {
  display: flex;
  height: var(--display-card-height);
  width: 100%;
  background-color: #000a14b3;
  border-radius: var(--border-display-radius);
}

.dc-display-card-image {
  display: flex;
  position: absolute;
  background-position: center center;
  height: var(--display-card-height);
  width: 100%;
  border-radius: var(--border-display-radius);
  background-size: cover;
  z-index: -1;
}

.dc-display-card-content {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  padding: calc(var(--display-card-height)/2) 24px 32px 24px;
  color: var(--dc-colour-white);
  font-family: var(--dc-font-family);
  justify-content: end;
  overflow: hidden;
}

.dc-display-card-heading {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-style: normal;
  font-weight: var(--dc-heading5-weight);
  font-size: var(--dc-heading5-size);
  line-height: 32px;
  text-shadow: 0 3px 6px #00000065;
  margin-bottom: 12px;
  overflow: hidden;
}

.dc-display-card-description {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  text-shadow: 0 3px 6px #00000065;
}

@media (--breakpoint-tablet) {
  .dc-display-card-content {
    padding: calc(var(--display-card-height)/2) 32px 32px 32px;
  }
}

@media (--breakpoint-desktop) {
  .dc-display-card-content {
    padding: calc(var(--display-card-height)/2) 32px 32px 32px;
  }
}

@media (--breakpoint-large-desktop) {
  .dc-display-card-content {
    padding: calc(var(--display-card-height)/2) 48px 46px 48px;
  }

  .dc-display-card-heading {
    font-size: var(--dc-heading4-size);
    line-height: 40px;
    margin-bottom: 14px;
  }
}

.dc-display-card-link:focus-visible {
  outline: 3px solid var(--dc-primary-colour);
  outline-offset: 2px;
}

.dc-display-card-link:hover .dc-display-card-media {
  background-color: color-mix(in oklch, transparent, var(--dc-primary-hover-color) 70%);
}

.dc-display-card-cta-wrapper {
  display: flex;
  margin-top: 16px;
}

.dc-display-card-cta-text {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  position: relative;
}

.dc-display-card-cta-text::before {
  content: " ";
  position: absolute;
  transform: scaleX(0);
  width: 0;
  height: 1px;
  left: 0;
  bottom: 0;
  transition: transform 0.25s ease-out;
}

.dc-display-card-link:hover .dc-display-card-cta-text::before {
  width: 100%;
  transform: scaleX(1);
  transform-origin: bottom left;
  background-color: var(--dc-colour-white);
}
